import React, { useState, useEffect } from "react";
import { Table, Input, Space, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ProfitTableModal from "./ProfitTableModal";
import ManagerService from "../../services/ManagerService";

const ProfitTable = ({ data }) => {
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedBienKiemSoat, setSelectedBienKiemSoat] = useState("");
  const [chartData, setChartData] = useState(null);
  const [modalData, setModalData] = useState([]);
  const [chartDtData, setChartDtData] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [columns, setColumns] = useState([[
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      render: (text, record, index) => index + 1,
      align: "center",
    },
    {
      title: "Biển kiểm soát",
      dataIndex: "bien_kiem_soat",
      key: "bien_kiem_soat",
      sorter: (a, b) => a.bien_kiem_soat.localeCompare(b.bien_kiem_soat),
      align: "center",
      render: (text) => (
        <Button type="link" onClick={() => handleRowClick(text)}>
          {text}
        </Button>
      ),
    },
    {
      title: "Loại xe",
      dataIndex: "loai_xe",
      key: "loai_xe",
      filters: [
        { text: "CONT LẠNH", value: "CONT LẠNH" },
        { text: "VTP", value: "VTP" },
      ],
      onFilter: (value, record) => record.loai_xe === value,
      align: "center",
    },
    {
      title: 'Tỷ lệ lợi nhuận (%)',
      dataIndex: "profitRate",
      key: "profitRate",
      sorter: (a, b) => parseFloat(a.profitRate) - parseFloat(b.profitRate),
      render: (text) => (
        <span className={parseFloat(text) >= 0 ? "text-success" : "text-danger"}>
          {parseFloat(text).toLocaleString()}%
        </span>
      ),
      align: "center",
    },
    {
      title: "Tổng chi phí (₫)",
      dataIndex: "tong_chi_phi",
      key: "tong_chi_phi",
      sorter: (a, b) => parseFloat(a.tong_chi_phi) - parseFloat(b.tong_chi_phi),
      render: (text) => parseFloat(text).toLocaleString("vi-VN"),
      align: "center",
    },
    {
      title: "Chi phí xe không hoạt động (₫)",
      dataIndex: "chi_phi_xe_khong_hoat_dong",
      key: "chi_phi_xe_khong_hoat_dong",
      sorter: (a, b) => parseFloat(a.chi_phi_xe_khong_hoat_dong) - parseFloat(b.chi_phi_xe_khong_hoat_dong),
      render: (text) => parseFloat(text).toLocaleString("vi-VN"),
      align: "center",
    },
    {
      title: "Tổng doanh thu (₫)",
      dataIndex: "tong_doanh_thu",
      key: "tong_doanh_thu",
      sorter: (a, b) => parseFloat(a.tong_doanh_thu) - parseFloat(b.tong_doanh_thu),
      render: (text) => parseFloat(text).toLocaleString("vi-VN"),
      align: "center",
    },
  ]]);
  const [pageSize, setPageSize] = useState(5); // Giá trị mặc định cho pageSize

  useEffect(() => {

    const countNegativeProfit = filteredData.filter((item) => parseFloat(item.profitRate) < 0).length;
    console.log(countNegativeProfit);
    setColumns([
      {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        render: (text, record, index) => index + 1,
        align: "center",
      },
      {
        title: "Biển kiểm soát",
        dataIndex: "bien_kiem_soat",
        key: "bien_kiem_soat",
        sorter: (a, b) => a.bien_kiem_soat.localeCompare(b.bien_kiem_soat),
        align: "center",
        render: (text) => (
          <Button type="link" onClick={() => handleRowClick(text)}>
            {text}
          </Button>
        ),
      },
      {
        title: "Loại xe",
        dataIndex: "loai_xe",
        key: "loai_xe",
        filters: [
          { text: "CONT LẠNH", value: "CONT LẠNH" },
          { text: "VTP", value: "VTP" },
        ],
        onFilter: (value, record) => record.loai_xe === value,
        align: "center",
      },
      {
        title: `Tỷ lệ lợi nhuận (%) (${countNegativeProfit})`,
        dataIndex: "profitRate",
        key: "profitRate",
        sorter: (a, b) => parseFloat(a.profitRate) - parseFloat(b.profitRate),
        render: (text) => (
          <span className={parseFloat(text) >= 0 ? "text-success" : "text-danger"}>
            {parseFloat(text).toLocaleString()}%
          </span>
        ),
        align: "center",
      },
      {
        title: "Tổng chi phí (₫)",
        dataIndex: "tong_chi_phi",
        key: "tong_chi_phi",
        sorter: (a, b) => parseFloat(a.tong_chi_phi) - parseFloat(b.tong_chi_phi),
        render: (text) => parseFloat(text).toLocaleString("vi-VN"),
        align: "center",
      },
      {
        title: "Chi phí xe không hoạt động (₫)",
        dataIndex: "chi_phi_xe_khong_hoat_dong",
        key: "chi_phi_xe_khong_hoat_dong",
        sorter: (a, b) => parseFloat(a.chi_phi_xe_khong_hoat_dong) - parseFloat(b.chi_phi_xe_khong_hoat_dong),
        render: (text) => parseFloat(text).toLocaleString("vi-VN"),
        align: "center",
      },
      {
        title: "Tổng doanh thu (₫)",
        dataIndex: "tong_doanh_thu",
        key: "tong_doanh_thu",
        sorter: (a, b) => parseFloat(a.tong_doanh_thu) - parseFloat(b.tong_doanh_thu),
        render: (text) => parseFloat(text).toLocaleString("vi-VN"),
        align: "center",
      },
    ])
  }, [filteredData])

  // Tìm kiếm
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = data.filter(
      (item) =>
        item.bien_kiem_soat.toLowerCase().includes(value) ||
        item.loai_xe.toLowerCase().includes(value)
    );

    setFilteredData(filtered);
  };

  // Khi nhấn vào hàng để xem chi tiết
  const handleRowClick = async (bienKiemSoat) => {
    setSelectedBienKiemSoat(bienKiemSoat);

    try {
      const currentDay = new Date().toISOString().split("T")[0];
      const response = await ManagerService.loadChiTietChuyenTheoXe(bienKiemSoat, currentDay);
      const data = response || [];
      setModalData(data);
      // Tổng hợp dữ liệu doanh thu
      const doanhThuBCKetNoi = data.reduce((sum, item) => sum + item.doanh_thu_bc_ket_noi, 0);
      // Gom nhóm doanh thu theo từng khách hàng
      const doanhThuTheoKhachHang = Object.entries(
        data.reduce((acc, item) => {
          const tenKH = item.ten_khach_hang; // Lấy tên khách hàng
          if (!tenKH) return acc; // Bỏ qua nếu tên khách hàng không xác định
      
          acc[tenKH] = (acc[tenKH] || 0) + item.doanh_thu_kd; // Cộng dồn doanh thu kinh doanh
          return acc;
        }, {})
      ).map(([name, value]) => ({ name, value }));
      // Tổng hợp dữ liệu cho biểu đồ
      const costCategories = [
        "cp_xang_dau",
        "cp_khau_hao",
        "cp_cau_duong",
        "cp_rua_xe",
        "cp_sua_chua",
        "luong_lx_theo_kg",
        "luong_lx_theo_km",
        "luong_chuyen_can_an_ca_dt",
        "cp_bhxh",
        "cp_boc_xep",
        "cp_quan_ly_cty",
      ];

      const chartValues = costCategories.map((key) =>
        data.reduce((sum, item) => sum + (item[key] || 0), 0)
      );

      setChartData({
        labels: [
          "CP xăng dầu",
          "CP khấu hao",
          "CP cầu đường",
          "CP rửa xe",
          "CP sửa chữa",
          "Lương LX theo kg",
          "Lương LX theo km",
          "Lương chuyển ca DT",
          "CP BHXH",
          "CP bốc xếp",
          "CP quản lý Cty",
        ],
        datasets: [
          {
            data: chartValues,
            backgroundColor: [
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
              "#C9CBCF",
              "#FF5733",
              "#33FF57",
              "#3357FF",
              "#FF33A2",
              "#A233FF",
            ],
          },
        ],
      });
      setChartDtData({
        labels: ["Doanh thu BC Kết nối", ...doanhThuTheoKhachHang.map((kh) => kh.name)],
        datasets: [
          {
            label: "Phân bổ Doanh thu",
            data: [doanhThuBCKetNoi, ...doanhThuTheoKhachHang.map((kh) => kh.value)],
            backgroundColor: ["#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40", "#C9CBCF", "#FF5733", "#33FF57", "#3357FF", "#FF33A2", "#A233FF"],
            hoverBackgroundColor: ["#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40", "#C9CBCF", "#FF5733", "#33FF57", "#3357FF", "#FF33A2", "#A233FF"],
          },
        ],
      });
      setIsModalVisible(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Tạo filter và sorter cho tất cả cột, xử lý chính xác cho cột kiểu số
  const getColumnSearchProps = (dataIndex, isNumber = false) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div>
          <button onClick={() => confirm()} style={{ marginRight: 8 }}>
            Search
          </button>
          <button onClick={clearFilters}>Reset</button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex] !== undefined && record[dataIndex] !== null
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : false,
    sorter: (a, b) =>
      isNumber
        ? (a[dataIndex] || 0) - (b[dataIndex] || 0) // So sánh số nếu là cột số
        : (a[dataIndex] || "").toString().localeCompare((b[dataIndex] || "").toString()),
    sortDirections: ["ascend", "descend"],
  });

  const modalColumns = [
    { title: "Biển kiểm soát", dataIndex: "bien_kiem_soat", key: "bien_kiem_soat", ...getColumnSearchProps("bien_kiem_soat") },
    { title: "Mã chuyến", dataIndex: "ma_chuyen", key: "ma_chuyen", ...getColumnSearchProps("ma_chuyen") },
    { title: "Lái xe", dataIndex: "lai_xe", key: "lai_xe", ...getColumnSearchProps("lai_xe") },
    { title: "SĐT lái xe", dataIndex: "so_dt_lai_xe", key: "so_dt_lai_xe", ...getColumnSearchProps("so_dt_lai_xe") },
    { title: "Tuyến", dataIndex: "tuyen", key: "tuyen" },
    { title: "Loại chạy", dataIndex: "loai_chay", key: "loai_chay", ...getColumnSearchProps("loai_chay") },
    { title: "Ngày kết nối", dataIndex: "ngay_ket_noi", key: "ngay_ket_noi", ...getColumnSearchProps("ngay_ket_noi") },
    { title: "Thời gian bắt đầu", dataIndex: "thoi_gian_bat_dau", key: "thoi_gian_bat_dau" },
    { title: "Thời gian kết thúc", dataIndex: "thoi_gian_ket_thuc", key: "thoi_gian_ket_thuc" },
    { title: "Điểm đi thực tế", dataIndex: "diem_di_thuc_te", key: "diem_di_thuc_te" },
    { title: "Điểm đến thực tế", dataIndex: "diem_den_thuc_te", key: "diem_den_thuc_te" },
    { title: "Trọng tải", dataIndex: "trong_tai", key: "trong_tai", ...getColumnSearchProps("trong_tai", true) },
    { title: "Hàng kinh doanh", dataIndex: "hang_kinh_doanh", key: "hang_kinh_doanh", ...getColumnSearchProps("hang_kinh_doanh", true) },
    { title: "Hàng bưu chính kết nối", dataIndex: "hang_buu_chinh_ket_noi", key: "hang_buu_chinh_ket_noi", ...getColumnSearchProps("hang_buu_chinh_ket_noi", true) },
    { title: "KM kinh doanh", dataIndex: "km_kinh_doanh", key: "km_kinh_doanh", ...getColumnSearchProps("km_kinh_doanh", true) },
    { title: "KM bưu chính kết nối", dataIndex: "km_buu_chinh_ket_noi", key: "km_buu_chinh_ket_noi", ...getColumnSearchProps("km_buu_chinh_ket_noi", true) },
    { title: "KM rỗng", dataIndex: "km_rong", key: "km_rong", ...getColumnSearchProps("km_rong", true) },
    { title: "Tên khách hàng", dataIndex: "ten_khach_hang", key: "ten_khach_hang", ...getColumnSearchProps("ten_khach_hang") },
    { title: "Doanh thu KD", dataIndex: "doanh_thu_kd", key: "doanh_thu_kd", ...getColumnSearchProps("doanh_thu_kd", true) },
    { title: "Doanh thu BC kết nối", dataIndex: "doanh_thu_bc_ket_noi", key: "doanh_thu_bc_ket_noi", ...getColumnSearchProps("doanh_thu_bc_ket_noi", true) },
    { title: "CP xăng dầu", dataIndex: "cp_xang_dau", key: "cp_xang_dau", ...getColumnSearchProps("cp_xang_dau", true) },
    { title: "CP khấu hao", dataIndex: "cp_khau_hao", key: "cp_khau_hao", ...getColumnSearchProps("cp_khau_hao", true) },
    { title: "CP cầu đường", dataIndex: "cp_cau_duong", key: "cp_cau_duong", ...getColumnSearchProps("cp_cau_duong", true) },
    { title: "CP rửa xe", dataIndex: "cp_rua_xe", key: "cp_rua_xe", ...getColumnSearchProps("cp_rua_xe", true) },
    { title: "CP sửa chữa", dataIndex: "cp_sua_chua", key: "cp_sua_chua", ...getColumnSearchProps("cp_sua_chua", true) },
    { title: "Lương LX theo kg", dataIndex: "luong_lx_theo_kg", key: "luong_lx_theo_kg", ...getColumnSearchProps("luong_lx_theo_kg", true) },
    { title: "Lương LX theo km", dataIndex: "luong_lx_theo_km", key: "luong_lx_theo_km", ...getColumnSearchProps("luong_lx_theo_km", true) },
    { title: "Lương chuyển ca DT", dataIndex: "luong_chuyen_can_an_ca_dt", key: "luong_chuyen_can_an_ca_dt", ...getColumnSearchProps("luong_chuyen_can_an_ca_dt", true) },
    { title: "CP BHXH", dataIndex: "cp_bhxh", key: "cp_bhxh", ...getColumnSearchProps("cp_bhxh", true) },
    { title: "CP bốc xếp", dataIndex: "cp_boc_xep", key: "cp_boc_xep", ...getColumnSearchProps("cp_boc_xep", true) },
    { title: "CP quản lý Cty", dataIndex: "cp_quan_ly_cty", key: "cp_quan_ly_cty", ...getColumnSearchProps("cp_quan_ly_cty", true) },
  ];

  return (
    <div>
      <h5 className="text-primary fw-bold mb-3 text-center">
        Bảng lợi nhuận của từng xe
      </h5>
      <Space style={{ marginBottom: 16 }}>
        <Input
          placeholder="Tìm kiếm biển kiểm soát hoặc loại xe"
          value={searchText}
          onChange={handleSearch}
          allowClear
          style={{ width: 300 }}
        />
      </Space>
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="bien_kiem_soat"
        pagination={{
          pageSize,
          showSizeChanger: true, // Hiển thị tùy chọn thay đổi số lượng phần tử trên mỗi trang
          pageSizeOptions: ["5", "10", "20", "50"], // Các tùy chọn số lượng phần tử
          onShowSizeChange: (current, size) => setPageSize(size), // Cập nhật pageSize khi người dùng thay đổi
        }}
        scroll={{ y: 350 }}
        bordered
      />
      <ProfitTableModal
        isModalVisible={isModalVisible}
        selectedBienKiemSoat={selectedBienKiemSoat}
        chartData={chartData}
        chartDtData={chartDtData}
        modalData={modalData}
        showDetails={showDetails}
        setShowDetails={setShowDetails}
        onClose={() => setIsModalVisible(false)}
        modalColumns={modalColumns}
      />
    </div>
  );
};

export default ProfitTable;
